import PropTypes from 'prop-types';
// form
import { FormProvider as Form } from 'react-hook-form';

// ----------------------------------------------------------------------

export default function FormProvider({ children, onSubmit, methods, isForTab, formStyle, onKeyDown }) {
    return (
        <Form {...methods} >
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions -- optional onKeyDown only ever guards implicit Enter-submits a caller opts into; it never adds new interactive behaviour to the form itself */}
            <form onSubmit={onSubmit} onKeyDown={onKeyDown} style={{ ...(isForTab ? { width: '100%' } : {}), ...formStyle }}>{children}</form>
        </Form>
    );
}

FormProvider.propTypes = {
    children: PropTypes.node.isRequired,
    methods: PropTypes.object.isRequired,
    onSubmit: PropTypes.func,
    isForTab: PropTypes.bool,
    formStyle: PropTypes.object,
    // Optional — lets a specific page opt into guarding against the browser's
    // implicit "Enter in a text input submits the form" behaviour (e.g. a
    // page with several plain text inputs where only an explicit button
    // click should ever submit). Omitted everywhere else, so existing pages
    // keep native Enter-to-submit behaviour unchanged.
    onKeyDown: PropTypes.func,
};